import { PaymentGroupSetting, Policy } from '../../apiTypes';

export const name = 'currentPolicy';

export const types = {
    SET_CURRENT_POLICY: `${name}/SET_CURRENT_POLICY`,
    SET_CURRENT_USER_POLICY: `${name}/SET_CURRENT_USER_POLICY`,
    SET_PAYMENT_GROUP_SETTINGS: `${name}/SET_PAYMENT_GROUP_SETTINGS`,
    CLEAR_ALL: `${name}/CLEAR_ALL`,
};

export interface CurrentPolicyState {
    policy: Policy;
    userPolicy: Policy;
    paymentGroupSettings: PaymentGroupSetting;
}

// InitialState
const initialState: CurrentPolicyState = {
    policy: null,
    userPolicy: null,
    paymentGroupSettings: null,
};

const reducer = (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.SET_CURRENT_POLICY:
            return {
                ...state,
                policy: action.payload.policy,
            };
        case types.SET_CURRENT_USER_POLICY:
            return {
                ...state,
                userPolicy: action.payload.userPolicy,
            };
        case types.SET_PAYMENT_GROUP_SETTINGS:
            return {
                ...state,
                paymentGroupSettings: action.payload.settings,
            };
        case types.CLEAR_ALL:
            return initialState;
        default:
            return state;
    }
};
export default reducer;

// ActionCreators
export const actions = {
    setCurrentPolicy: (policy: Policy): any => ({ type: types.SET_CURRENT_POLICY, payload: { policy } }), // Also impact currentBooking
    setCurrentUserPolicy: (policy: Policy, userPolicy: Policy, groupId: string): any => ({
        type: types.SET_CURRENT_USER_POLICY,
        payload: { policy, userPolicy, groupId },
    }), // Also impact currentBooking
    setCurrentPaymentGroupSettings: (settings: PaymentGroupSetting): any => ({
        type: types.SET_PAYMENT_GROUP_SETTINGS,
        payload: { settings },
    }),
    resetAll: (): any => ({ type: types.CLEAR_ALL }),
};

const localState = (state: any): CurrentPolicyState => state[name] || initialState;
export const selectors = {
    currentPolicy: (state): Policy => localState(state).policy,
    currentUserPolicy: (state): Policy => localState(state).userPolicy,
    paymentGroupSettings: (state): PaymentGroupSetting => localState(state).paymentGroupSettings,
};
